"use strict";

require("core-js/modules/es.symbol.description.js");
require("core-js/modules/es.weak-map.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.EditableReadonlyField = void 0;
require("core-js/modules/web.dom-collections.iterator.js");
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _EditModeToggle = require("../../Buttons/EditModeToggle");
require("./EditableReadonlyField.scss");
var _propTypes2 = require("../../../../../propTypes");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const EditableReadonlyField = _ref => {
  let {
    fieldElement,
    onEditModeChange = () => {},
    editButton = {
      label: 'Change postcode',
      hideLabel: true,
      icon: 'pencil'
    },
    customCssClass
  } = _ref;
  const [editMode, setEditMode] = (0, _react.useState)(false);
  const HandleEditModeChange = mode => {
    setEditMode(mode);
    onEditModeChange(mode);
  };
  return /*#__PURE__*/_react.default.createElement("fieldset", {
    className: "formField editableReadonlyField ".concat(customCssClass || '')
  }, fieldElement, /*#__PURE__*/_react.default.createElement(_EditModeToggle.EditModeToggle, {
    editMode,
    onEditModeChange: HandleEditModeChange
  }));
};
exports.EditableReadonlyField = EditableReadonlyField;
EditableReadonlyField.propTypes = {
  fieldElement: _propTypes.default.oneOfType([_propTypes.default.element, _propTypes.default.func]),
  onEditModeChange: _propTypes.default.func,
  editButton: _propTypes.default.shape(_objectSpread(_objectSpread({}, _propTypes2.FieldLabelTextPropTypes), {}, {
    icon: _propTypes.default.string
  })),
  customCssClass: _propTypes.default.string
};
var _default = exports.default = {
  EditableReadonlyField
};